// src/config/admin.config.ts — SCE Issues
// Référentiel des administrateurs applicatifs.
//
// ─── Pourquoi une config dédiée ───
//
// L'UPN admin était dupliqué dans AdminPage.tsx ET le tiroir de navigation
// (supprimé depuis, remplacé par MenuCompte.tsx) : deux
// vérités pour une même règle. Le jour où l'administration passe à deux
// personnes (congés, passation), une seule des deux copies est modifiée et le
// tiroir masque un lien vers une page pourtant accessible — ou l'inverse.
//
// Même convention que coordinateurs.config.ts : la liste vit ici, les pages
// consomment le helper.

/**
 * UPN des administrateurs applicatifs.
 *
 * Donne accès à /admin (quarantaine Windchill + import du référentiel).
 * Une liste plutôt qu'une constante unique : la passation à un second
 * administrateur ne doit pas demander de retoucher la logique.
 */
export const ADMINS_UPN: readonly string[] = [
  'guillaume.delavault1@sartorius.com',
]

/**
 * Vérifie qu'un UPN est administrateur.
 *
 * ⚠️ Comparaison insensible à la casse : Azure AD ne garantit pas la casse de
 * l'UPN, et une comparaison stricte peut verrouiller l'admin hors de sa propre
 * page. Même précaution que `isCoordinateur()`.
 */
export function estAdmin(upn: string): boolean {
  if (!upn) return false
  const cible = upn.toLowerCase()
  return ADMINS_UPN.some((u) => u.toLowerCase() === cible)
}
